import { createReducer, on } from '@ngrx/store';
import { initialState } from './forms-data.state';
import {
  changeConfirmFormData,
  changeDeliveryCourierFormData,
  changeDeliveryPointFormData,
  changeShipmentFormData,
  changeShippingCourierFormData,
  changeShippingPointFormData,
  changeSelectedPartners,
} from './forms-data.actions';

export const formsDataReducer = createReducer(
  initialState,
  on(changeShippingCourierFormData, (state, { shippingCourierFormData }) => ({
    ...state,
    shippingCourierFormData: shippingCourierFormData,
  })),
  on(changeShippingPointFormData, (state, { shippingPointFormData }) => ({
    ...state,
    shippingPointFormData: shippingPointFormData,
  })),
  on(changeShipmentFormData, (state, { shipmentFormData }) => ({
    ...state,
    shipmentFormData: shipmentFormData,
  })),
  on(changeDeliveryCourierFormData, (state, { deliveryCourierFormData }) => ({
    ...state,
    deliveryCourierFormData: deliveryCourierFormData,
  })),
  on(changeDeliveryPointFormData, (state, { deliveryPointFormData }) => ({
    ...state,
    deliveryPointFormData: deliveryPointFormData,
  })),
  on(changeConfirmFormData, (state, { confirmFormData }) => ({
    ...state,
    confirmFormData: confirmFormData,
  })),
  on(changeSelectedPartners, (state, { selectedPartners }) => ({
    ...state,
    selectedPartners: selectedPartners,
  }))
);
